/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export class Valorisation {
  constructor(json: JSON | any) {
    Object.assign(this as Valorisation, json)
  }

  startOfValidity?: number
  endOfValidity?: number
  predicate?: string
  reference?: Array<number>
  totalAmount?: number
  reimbursement?: number
  patientIntervention?: number
  doctorSupplement?: number
  vat?: number
  label?: { [key: string]: string }
  /**
   * The base64 encoded data of this object, formatted as JSON and encrypted in AES using the random master key from encryptionKeys.
   */
  encryptedSelf?: string
}
